module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAxIiBoZWlnaHQ9IjIyNSIgdmlld0JveD0iMCAwIDMwMSAyMjUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbC1ydWxlPSJub256ZXJvIiBmaWxsPSJub25lIj48cGF0aCBmaWxsPSIjM0E3NUM0IiBkPSJNLjUgMGgzMDB2MjI1SC41eiIvPjxwYXRoIGZpbGw9IiNGQ0QxMTYiIGQ9Ik0uNSAwaDMwMHYxNTBILjV6Ii8+PHBhdGggZmlsbD0iIzAwOUU2MCIgZD0iTS41IDBoMzAwdjc1SC41eiIvPjwvZz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/svg/flag/cif-ga.svg
// module id = TPgX
// module chunks = 2